import { Component } from 'react';
import '../styles/Holding.css';

const THEMES = [
  { id: 'midnight', label: 'Midnight', color: '#0A1628' },
  { id: 'desert', label: 'Desert', color: '#C8956C' },
  { id: 'oasis', label: 'Oasis', color: '#2D6A4F' },
  { id: 'arctic', label: 'Arctic', color: '#E8EDF2' },
];

class HoldingLayout extends Component {
  constructor(props) {
    super(props);
    const saved = localStorage.getItem('holding-theme') || 'midnight';
    const savedDark = localStorage.getItem('holding-dark') !== 'false';
    this.state = { theme: saved, darkMode: savedDark };
  }

  setTheme = (id) => {
    localStorage.setItem('holding-theme', id);
    this.setState({ theme: id });
  };

  toggleDarkMode = () => {
    const next = !this.state.darkMode;
    localStorage.setItem('holding-dark', next);
    this.setState({ darkMode: next });
  };

  render() {
    const { theme, darkMode } = this.state;
    const year = new Date().getFullYear();
    const modeClass = darkMode ? 'h-dark' : 'h-light';

    return (
      <div className={`h-root h-theme-${theme} ${modeClass}`}>
        {/* Navigation */}
        <nav className="h-nav">
          <div className="h-nav-inner">
            <a href="/" className="h-nav-logo">
              <img src="/images/rakeen-logo.png" alt="Rakeen" className="h-nav-logo-img" />
              <span className="h-nav-logo-text">Rakeen</span>
            </a>
            <div className="h-nav-links">
              <a href="/#products" className="h-nav-link">Products</a>
              <a href="/#about" className="h-nav-link">About</a>
              <a href="/contact" className="h-nav-link">Contact</a>
              <button
                className="h-dark-toggle"
                onClick={this.toggleDarkMode}
                aria-label={darkMode ? 'Switch to light mode' : 'Switch to dark mode'}
                title={darkMode ? 'Light mode' : 'Dark mode'}
              >
                {darkMode ? (
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <circle cx="12" cy="12" r="5"/><line x1="12" y1="1" x2="12" y2="3"/><line x1="12" y1="21" x2="12" y2="23"/><line x1="4.22" y1="4.22" x2="5.64" y2="5.64"/><line x1="18.36" y1="18.36" x2="19.78" y2="19.78"/><line x1="1" y1="12" x2="3" y2="12"/><line x1="21" y1="12" x2="23" y2="12"/><line x1="4.22" y1="19.78" x2="5.64" y2="18.36"/><line x1="18.36" y1="5.64" x2="19.78" y2="4.22"/>
                  </svg>
                ) : (
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"/>
                  </svg>
                )}
              </button>
            </div>
          </div>
        </nav>

        {/* Theme Switcher */}
        <div className="h-theme-switcher">
          {THEMES.map((t) => (
            <button
              key={t.id}
              className={`h-theme-dot ${theme === t.id ? 'active' : ''}`}
              style={{ '--dot-color': t.color }}
              onClick={() => this.setTheme(t.id)}
              title={t.label}
              aria-label={`Switch to ${t.label} theme`}
            />
          ))}
        </div>

        {/* Page Content */}
        <main className="h-layout-content">
          {this.props.children}
        </main>

        {/* Footer */}
        <footer className="h-footer">
          <div className="h-footer-inner">
            <div className="h-footer-top">
              <div className="h-footer-brand">
                <img src="/images/rakeen-logo.png" alt="Rakeen" className="h-footer-logo" />
                <span className="h-footer-name">Rakeen</span>
              </div>
              <div className="h-footer-links">
                <a href="/privacy" className="h-footer-link">Privacy</a>
                <a href="/terms" className="h-footer-link">Terms</a>
                <a href="/contact" className="h-footer-link">Contact</a>
              </div>
            </div>
            <div className="h-footer-bottom">
              <span>&copy; {year} Rakeen. All rights reserved.</span>
              <span className="h-footer-location">Khobar, Saudi Arabia</span>
            </div>
          </div>
        </footer>
      </div>
    );
  }
}

export default HoldingLayout;
